import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'
import { AlmanacFile } from 'types'
import { reportError } from 'utils/error'

export const useLastUsedProject = (workspaceId: number) => {
  return useQuery<{ project: AlmanacFile | null }>(
    ['lastUsedProject', workspaceId],
    async () => {
      const res = await WorkspaceClient.getLastUsedProject(workspaceId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Error fetching the last used project')
      }
      return res.data
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      onError: reportError,
    },
  )
}
